import { isValidElement } from 'react';
import {
    AlertTriangle, Ban, Bell, Bike, CheckCircle2, Clock, FileText, Hourglass, Map, MapPin,
    Megaphone, Package, Plug, RefreshCw, Siren, Store, Truck, User, Users, UtensilsCrossed,
    Wallet, XCircle,
} from 'lucide-react';

/**
 * Bildirim simgesi — tek sözlük.
 *
 * Bildirim tanımları (toast, kayan kart, zil listesi) simgeyi ANAHTAR olarak taşır; çizim
 * burada yapılır. Öncesinde tanımlar emoji taşıyordu: her işletim sisteminde farklı çiziliyor,
 * temaya uymuyor ve panelin geri kalanındaki çizgi ikonlarla yan yana durmuyordu.
 */
const ICONS = {
    alert: AlertTriangle,
    ban: Ban,
    bell: Bell,
    bike: Bike,
    check: CheckCircle2,
    clock: Clock,
    file: FileText,
    hourglass: Hourglass,
    map: Map,
    megaphone: Megaphone,
    package: Package,
    pin: MapPin,
    plug: Plug,
    refresh: RefreshCw,
    siren: Siren,
    store: Store,
    truck: Truck,
    user: User,
    users: Users,
    utensils: UtensilsCrossed,
    wallet: Wallet,
    x: XCircle,
};

const NotifyIcon = ({ name, size = 18 }) => {
    // Hazır bir öğe verildiyse (ör. fleetToast'ın kendi ikonları) olduğu gibi çizilir.
    if (isValidElement(name)) return name;
    const Icon = ICONS[name] || Bell;
    return <Icon size={size} aria-hidden="true" />;
};

export default NotifyIcon;
